import { TipoStatusNotificacaoEnum } from "../enums/tipo-status-notificacao-enum";
import { NotificacaoSms } from "./notificacao-sms";
import { LoteNotificacaoSmsPK } from "./pks/lote-notificacao-sms-pk";
import { StatusNotificacaoSms } from "./status-notificacao-sms";

export class LoteNotificacaoSms {

    pk: LoteNotificacaoSmsPK = new LoteNotificacaoSmsPK();

    loginUsuarioNotificacao: string = '';

    statusNotificacaoSms: StatusNotificacaoSms = new StatusNotificacaoSms();

    tipoStatusNotificacao: TipoStatusNotificacaoEnum = TipoStatusNotificacaoEnum.SUC;

    listaNotificacaoSms: Array<NotificacaoSms> = [];

    dscMotivoNotificacao: string = '';

    dscMensagemNotificacao: string = '';

    constructor() {
    }

}
